import { consumptionAPI } from "./clients";

/**
 * Endpoint to get the list of all DataSource available
 */
const getDataSourceList = () => {
  const endpoint = "/datasources";
  return consumptionAPI.get(endpoint);
};

/**
 * Endpoint to get details of a single DataSource
 * @param {String} dataSourceId
 */
const getDataSourceDetails = dataSourceId => {
  const endpoint = `/datasources/${dataSourceId}`;
  return consumptionAPI.get(endpoint);
};

export { getDataSourceList, getDataSourceDetails };
